import React, { Suspense, lazy } from 'react';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { StickyBar } from '../components/StickyBar';
import { PromoBanner } from '../components/PromoBanner';
// Lazy load below-fold sections for faster initial render
const TruthSection = lazy(() => import('../components/TruthSection').then(m => ({
  default: m.TruthSection
})));
const MethodSection = lazy(() => import('../components/MethodSection').then(m => ({
  default: m.MethodSection
})));
const OfferSection = lazy(() => import('../components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const ObjectionsSection = lazy(() => import('../components/ObjectionsSection').then(m => ({
  default: m.ObjectionsSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const ExitIntent = lazy(() => import('../components/ExitIntent').then(m => ({
  default: m.ExitIntent
})));
function LazyFallback() {
  return <div className="min-h-[200px]" data-id="element-390" />;
}
export function SalesPage() {
  return <main className="min-h-screen bg-[#0a1628] text-white selection:bg-[#d4af37] selection:text-[#0a1628]" data-id="element-391">
      {/* Promo banner — first impression */}
      <PromoBanner data-id="element-392" />

      {/* Above the fold — loaded immediately */}
      <Hero data-id="element-393" />
      <PainSection data-id="element-394" />

      {/* Below the fold — lazy loaded */}
      <Suspense fallback={<LazyFallback data-id="element-396" />} data-id="element-395">
        <TruthSection data-id="element-397" />
        <MethodSection data-id="element-398" />
        <OfferSection data-id="element-399" />
        <BonusSection data-id="element-400" />
        <PricingSection data-id="element-401" />
        <ObjectionsSection data-id="element-402" />
        <Footer data-id="element-403" />
        <ExitIntent data-id="element-404" />
      </Suspense>

      {/* StickyBar loaded immediately (fixed position, small) */}
      <StickyBar data-id="element-405" />
    </main>;
}